import { ReactNode } from 'react';
import { Space, Typography } from 'antd';

type ItemProps = {
    name: string;
    value: string;
    icon?: ReactNode;
};

const CalculationsHeaderSummaryItem = ({ name, value, icon }: ItemProps) => {
    return (
        <span style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
            <Space size={6}>
                {icon}
                <Typography>{name}:</Typography>
            </Space>
            <strong>
                <Typography>{value}</Typography>
            </strong>
        </span>
    );
};

export default CalculationsHeaderSummaryItem;
